import styled from 'styled-components';

export const LogoImage = styled.img`
    display: block;
    height: 100%;
    width: auto;
    max-width: 100%;
    object-fit: contain;
`;

export const LogoFallback = styled.span`
    color: ${({ theme }) => theme?.colors?.gray?.[500] || '#6B7280'};
    font-size: 13px;
    font-weight: 600;
`;

export const ProfileLogoWrap = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const ProfileLogoFrame = styled.div`
    width: min(100%, 640px);
    aspect-ratio: 640 / 225;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    padding: 12px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
